import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

/**
 * @file 列表页-自定义内容区域
 * @author cynthiawu
 */
import React from 'react';
;

var CustomMainArea = function CustomMainArea(props) {
  var prefixCls = props.prefixCls,
      tableConfig = props.tableConfig,
      listProps = _objectWithoutProperties(props, ["prefixCls", "tableConfig"]);

  var CustomComponent = tableConfig.customMainArea;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "__main-custom-area")
  }, /*#__PURE__*/React.createElement(CustomComponent, listProps));
}; // 【必须】必须定义defaultProps，触发storybook ArgsTable 默认值


CustomMainArea.defaultProps = {};
export default CustomMainArea;